const CHOICE_COOKIE_NAME = "taas_monthly_upsell_choice";
const CHOICE_MAX_AGE = 60 * 60 * 24 * 30;

const getCookie = (name) => {
	if (typeof document === "undefined") return null;
	const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1");
	const match = document.cookie.match(
		new RegExp(`(?:^|; )${escaped}=([^;]*)`),
	);
	return match ? decodeURIComponent(match[1]) : null;
};

export const MONTHLY_UPSELL_MAX_SINGLE_AMOUNT = 80;

export const isSingleAmountEligibleForMonthlyUpsell = (
	singleAmount,
	maxSingleAmount = MONTHLY_UPSELL_MAX_SINGLE_AMOUNT,
) => {
	const amount = Number(singleAmount);
	if (!Number.isFinite(amount)) return false;
	return amount < maxSingleAmount;
};

const MONTHLY_UPSELL_FLOOR = 5;

/**
 * At or below £5 one-off: suggest 100% of the one-off amount.
 * Above that: 0.4 × single amount, rounded to nearest £5, floored at £5.
 * e.g. £5 → £5, £10 → £5, £20 → £10, £50 → £20
 */
export const calculateSuggestedMonthlyAmount = (singleAmount) => {
	const amount = Number(singleAmount);

	if (!Number.isFinite(amount) || amount <= 0) {
		return MONTHLY_UPSELL_FLOOR;
	}

	if (amount <= MONTHLY_UPSELL_FLOOR) {
		return amount;
	}

	const raw = amount * 0.4;
	const rounded = Math.round(raw / 5) * 5;
	return Math.max(MONTHLY_UPSELL_FLOOR, rounded);
};

export const formatOfferAmount = (amount) =>
	Number(amount).toLocaleString("en-GB", {
		maximumFractionDigits: 0,
		minimumFractionDigits: 0,
	});

export const buildOfferTitle = (monthlyAmount) =>
	`Give £${formatOfferAmount(monthlyAmount)} per month instead`;

export const getMonthlyUpsellChoice = (config = {}) => {
	const fromConfig = config?.choice;
	if (fromConfig === "accepted" || fromConfig === "declined") {
		return fromConfig;
	}

	const fromCookie = getCookie(CHOICE_COOKIE_NAME);
	if (fromCookie === "accepted" || fromCookie === "declined") {
		return fromCookie;
	}

	return null;
};

export const setMonthlyUpsellChoice = (
	choice,
	{ path = "/", domain } = {},
) => {
	if (typeof document === "undefined") return;
	if (choice !== "accepted" && choice !== "declined") return;

	let cookie = `${CHOICE_COOKIE_NAME}=${encodeURIComponent(choice)}; max-age=${CHOICE_MAX_AGE}; path=${path}; SameSite=Lax`;

	if (domain) {
		cookie += `; domain=${domain}`;
	}

	if (typeof window !== "undefined" && window.location.protocol === "https:") {
		cookie += "; secure";
	}

	document.cookie = cookie;
};

export const isMonthlyUpsellDismissed = (config = {}) =>
	getMonthlyUpsellChoice(config) !== null;
